import axios from "axios";

class CompanyService {
    getBountiesSummary() {
        return axios.get(`company/dashboard/bounties-summary`);
    }
    getReportsSummary(year) {
        return axios.get(`company/reports/summary?year=${year}`);
    }
    getReportsSituationSummary() {
        return axios.get(`company/dashboard/reports-situation-summary`);
    }
    getPayments(payload) {
        return axios.get( `company/dashboard/payments?${payload}` );
    }
    getMembers() {
        return axios.get(`company/members`);
    }
    putMembers(email) {
        return axios.put(`company/members/status/${email}`);
    }
    putProgramMembers(id, invitation, payload) {
        return axios.put(`company/member-access/${id}?invitation=${invitation}`, payload);
    }
    putMembersRole(userId, newRole, pending) {
        return axios.put(`company/member/${userId}/${newRole}${pending ? '?invitation=true' : ''}`);
    }
    deleteMembers(email) {
        return axios.delete(`company/members/status/${email}`);
    }
    postMembers(payload) {
        return axios.post(`company/invitation`, payload);
    }
    getGeneralSummary() {
        return axios.get(`company/general-summary`);
    }
    getProvisionsSummary() {
        return axios.get(`company/provisions-summary`);
    }
    getReportSummary(initalDate, finalDate) {
        return axios.get(`company/reports/summary/payments?initialDate=${initalDate}&finalDate=${finalDate}`);
    }
    getCompany() {
        return axios.get(`company`);
    }
    getTags() {
        return axios.get(`company/report-tags`);
    }
    getCompanyIntegration() {
        return axios.get(`company/integration`);
    }
    putCompany(payload) {
        return axios.put(`company`, payload);
    }
    putTags(payload) {
        return axios.put(`company/report-tags`, payload);
    }
    putCompanyIntegration(payload) {
        return axios.put(`company/integration/`, payload);
    }
    deleteCompanyIntegration(payload) {
        return axios.delete(`company/integration/`, {data: payload}); 
    }
    deleteCompanyToken() {
        return axios.delete(`company/ext-token/`); 
    }
    getJobAdvertisement(payload) {

       let query = "";
  
        query += payload.page ? `page=${payload.page}` : "";
        query += payload.pageSize ? `&pageSize=${payload.pageSize}` : ""; 
        query += payload.title ? `&title=${payload.title}` : "";
        query += payload.location ? `&location=${payload.location}` : "";

        query += payload.contract_type ? `&contract_type=${payload.contract_type}` : "";
        query += payload.work_schedule ? `&work_schedule=${payload.work_schedule}` : "";
        query += payload.work_model ? `&work_model=${payload.work_model}` : "";
  
        return axios.get( `company/job-advertisement?${query}` );
    }

    getJobListFilters() { 
        return axios.get( `company/job-board/list-filters` );
    }
    postJobAdvertisement(payload) { 
        return axios.post( `company/job-advertisement`, payload ); 
    }

    putJobAdvertisement(id) { 
        return axios.put( `company/job-advertisement/${id}`); 
    }
    postMessageDefault(payload) { 
        return axios.post( `company/standard-message`, payload ); 
    }
    getMessageDefault() { 
        return axios.get( `company/standard-message`);
    }
    putMessageDefault(id, payload) { 
        return axios.put( `company/standard-message/${id}`, payload); 
    }
    deleteMessageDefault(id) { 
        return axios.delete( `company/standard-message/${id}`); 
    }
    putPasswordConfig(payload) { 
        return axios.put( `/company/password-config`, payload); 
    }
    putEmailAuthentication(payload) { 
        return axios.put( `/company/email_code`, payload); 
    }
    putCompany2fa(payload) { 
        return axios.put( `/company/2fa-required`, payload); 
    }
    puthHacker2fa(programId, payload) { 
        return axios.put( `/program/${programId}/2fa-required`, payload); 
    }
}

export default new CompanyService();